import {
    SENDING_APP_FEEDBACK,
    SENDING_APP_FEEDBACK_SUCCESS,
    SENDING_APP_FEEDBACK_FAILURE,
    RESET_SENDING_APP_FEEDBACK,
    SENDING_CONTACT_REQUEST,
    SENDING_CONTACT_REQUEST_SUCCESS,
    SENDING_CONTACT_REQUEST_FAILURE,
    RESET_SENDING_CONTACT_REQUEST,
    SENDING_LINK_REQUEST,
    SENDING_LINK_REQUEST_SUCCESS,
    SENDING_LINK_REQUEST_FAILURE,
    RESET_SENDING_LINK_REQUEST,
    SENDING_LINK_FEEDBACK,
    SENDING_LINK_FEEDBACK_SUCCESS,
    SENDING_LINK_FEEDBACK_FAILURE,
    RESET_SENDING_LINK_FEEDBACK,
} from 'redux/reduxConstants';

const feedbackState = {
    sendingAppFeedback: false,
    sendingAppFeedbackSuccess: false,
    sendingContactRequest: false,
    sendingContactRequestSuccess: false,
    sendingLinkRequest: false,
    sendingLinkRequestSuccess: false,
    sendingLinkFeedback: false,
    sendingLinkFeedbackSuccess: false,
    error: '',
};

const feedback = (state = feedbackState, action) => {
    switch (action.type) {
        case SENDING_APP_FEEDBACK:
            let sendingAppFeedbackState = { ...state };
            sendingAppFeedbackState.sendingAppFeedback = true;

            return sendingAppFeedbackState;

        case SENDING_APP_FEEDBACK_SUCCESS:
            let sendingAppFeedbackSuccessState = { ...state };
            sendingAppFeedbackSuccessState.sendingAppFeedback = false;
            sendingAppFeedbackSuccessState.sendingAppFeedbackSuccess = true;

            return sendingAppFeedbackSuccessState;

        case SENDING_APP_FEEDBACK_FAILURE:
            let sendingAppFeedbackFailureState = { ...state };
            sendingAppFeedbackFailureState.sendingAppFeedback = false;
            sendingAppFeedbackFailureState.error = action.error;

            return sendingAppFeedbackFailureState;

        case RESET_SENDING_APP_FEEDBACK:
            let resetSendingAppFeedbackState = { ...state };
            resetSendingAppFeedbackState.sendingAppFeedbackSuccess = true;

            return resetSendingAppFeedbackState;

        case SENDING_CONTACT_REQUEST:
            let sendingContactRequestState = { ...state };
            sendingContactRequestState.sendingContactRequest = true;

            return sendingContactRequestState;

        case SENDING_CONTACT_REQUEST_SUCCESS:
            let sendingContactRequestSuccessState = { ...state };
            sendingContactRequestSuccessState.sendingContactRequest = false;
            sendingContactRequestSuccessState.sendingContactRequestSuccess = true;

            return sendingContactRequestSuccessState;

        case SENDING_CONTACT_REQUEST_FAILURE:
            let sendingContactRequestFailureState = { ...state };
            sendingContactRequestFailureState.sendingContactRequest = false;
            sendingContactRequestFailureState.error = action.error;

            return sendingContactRequestFailureState;

        case RESET_SENDING_CONTACT_REQUEST:
            let resetSendingContactRequestState = { ...state };
            resetSendingContactRequestState.sendingContactRequestSuccess = true;

            return resetSendingContactRequestState;

        case SENDING_LINK_REQUEST:
            let sendingLinkRequestState = { ...state };
            sendingLinkRequestState.sendingLinkRequest = true;

            return sendingLinkRequestState;

        case SENDING_LINK_REQUEST_SUCCESS:
            let sendingLinkRequestSuccessState = { ...state };
            sendingLinkRequestSuccessState.sendingLinkRequestSuccess = true;
            sendingLinkRequestSuccessState.sendingLinkRequest = false;
            return sendingLinkRequestSuccessState;

        case SENDING_LINK_REQUEST_FAILURE:
            let sendingLinkRequestFailureState = { ...state };
            sendingLinkRequestFailureState.sendingLinkRequest = false;
            sendingLinkRequestFailureState.error = action.error;
            return sendingLinkRequestFailureState;

        case RESET_SENDING_LINK_REQUEST:
            let resetSendingLinkRequestState = { ...state };
            resetSendingLinkRequestState.sendingLinkRequestSuccess = false;
            return resetSendingLinkRequestState;

        case SENDING_LINK_FEEDBACK:
            let sendingLinkFeedbackState = { ...state };
            sendingLinkFeedbackState.sendingLinkFeedback = true;

            return sendingLinkFeedbackState;

        case SENDING_LINK_FEEDBACK_SUCCESS:
            let sendingLinkFeedbackSuccessState = { ...state };
            sendingLinkFeedbackSuccessState.sendingLinkFeedbackSuccess = true;
            sendingLinkFeedbackSuccessState.sendingLinkFeedback = false;
            return sendingLinkFeedbackSuccessState;

        case SENDING_LINK_FEEDBACK_FAILURE:
            let sendingLinkFeedbackFailureState = { ...state };
            sendingLinkFeedbackFailureState.sendingLinkFeedback = false;
            sendingLinkFeedbackFailureState.error = action.error;
            return sendingLinkFeedbackFailureState;

        case RESET_SENDING_LINK_FEEDBACK:
            let resetSendingLinkFeedbackState = { ...state };
            resetSendingLinkFeedbackState.sendingLinkFeedbackSuccess = false;
            return resetSendingLinkFeedbackState;

        default:
            return state;
    }
};

export default feedback;
